
import { CacheEntry } from './cacheConfig';

/**
 * Cache validation utilities
 */
export const isCacheExpired = (entry: CacheEntry): boolean => {
  return Date.now() > entry.expiresAt;
};

export const isCacheVersionValid = (entry: CacheEntry, expectedVersion: string): boolean => {
  return entry.version === expectedVersion;
};
